export default {
  formatStay: function (stay) {
    let hour = Math.floor(stay / 3600)
    let minute = Math.floor((stay % 3600) / 60)
    hour = hour || 0
    minute = minute || 0
    let pad = '00'
    return hour + ':' + pad.substring(0, pad.length - minute.toString().length) + minute
  },
  getCookie: function (cname) {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  },
  divide: function (a, b) {
    if (!a || !b || b === 0) {
      return 0
    }
    return a / b
  },
}



// WEBPACK FOOTER //
// ./src/misc/utils.js